import apiService from '../utils/apiInterceptor';

const categoryService = {
  getAllCategories: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      const normalizedParams = params && typeof params === 'object'
        ? params
        : { category_type_id: params };

      if (normalizedParams.page) queryParams.append('page', normalizedParams.page);
      if (normalizedParams.limit) queryParams.append('limit', normalizedParams.limit);
      if (normalizedParams.search) queryParams.append('search', normalizedParams.search);
      if (normalizedParams.category_type_id) queryParams.append('category_type_id', normalizedParams.category_type_id);
      if (normalizedParams.type_id) queryParams.append('type_id', normalizedParams.type_id);
      if (normalizedParams.status !== null && normalizedParams.status !== undefined) {
        queryParams.append('status', normalizedParams.status);
      }

      const queryString = queryParams.toString();
      const url = `/admin/category${queryString ? `?${queryString}` : ''}`;
      const response = await apiService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  getCategoryById: async (id) => {
    try {
      const response = await apiService.get(`/admin/category/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  createCategory: async (categoryData) => {
    try {
      const response = await apiService.post('/admin/category', categoryData);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateCategory: async (id, categoryData) => {
    try {
      const response = await apiService.put(`/admin/category/${id}`, categoryData);
      return response;
    } catch (error) {
      throw error;
    }
  },

  deleteCategory: async (id) => {
    try {
      const response = await apiService.delete(`/admin/category/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateCategoryStatus: async (id, status) => {
    try {
      const response = await apiService.post('/admin/change-category-status', {
        category_id: id,
        status: status
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getCategoryTypes: async () => {
    try {
      const response = await apiService.get('/admin/category-type');
      return response;
    } catch (error) {
      throw error;
    }
  },

  getCategoryTypeById: async (id) => {
    try {
      const response = await apiService.get(`/admin/category-type/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  createCategoryType: async (categoryTypeData) => {
    try {
      const response = await apiService.post('/admin/category-type', categoryTypeData);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateCategoryType: async (id, categoryTypeData) => {
    try {
      const response = await apiService.put(`/admin/category-type/${id}`, categoryTypeData);
      return response;
    } catch (error) {
      throw error;
    }
  },

  deleteCategoryType: async (id) => {
    try {
      const response = await apiService.delete(`/admin/category-type/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  }
};

export default categoryService;
